import { SERVER_API } from 'SharedDir/constants/app/endpoints';

// todo: заменить
export const DOCUMENTS_URL = `${SERVER_API}/documents`;
